<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="600px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.detailForm.cancel()"
    >
      <DetailForm
        ref="detailForm"
        :techProcessesCode="techProcessesCode"
        :orderCode="orderCode"
        :techCode="techCode"
        :disabled="disabled"
        @close="$emit('update:visible', false)"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.detailForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.detailForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DetailForm from './index.vue'
export default {
  components: { DetailForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    techProcessesCode: String,
    orderCode: String,
    techCode: String,
    disabled: { type: Boolean, default: true },
  },
}
</script>
